import classNames from "classnames";
import React from "react";

import { PolymorphicComponentProps } from "lib/@types/utils/polymorphic.types";

export type BadgeComponentProps = {
    color?: string;
    pill?: boolean;
};

export type BadgeProps<T extends React.ElementType> = PolymorphicComponentProps<
    T,
    BadgeComponentProps,
    "span" | "a"
>;

const Badge = <T extends React.ElementType = "span">({
    className,
    color = "secondary",
    pill = false,
    tag,
    ...attributes
}: BadgeProps<T>) => {
    const Tag = tag || ("span" as React.ElementType);
    const classes = classNames(
        className,
        "badge",
        pill ? "badge-pill" : false,
        "badge-" + color,
    );

    return <Tag {...attributes} className={classes} />;
};

export { Badge };
